export default __webpack_public_path__ + "static/media/home_main_bg.c99e6487.jpeg";